var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg166(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 1.1665V12.8332L3.50065 12.2498L4.66732 12.8332L5.83398 12.2498L7.00065 12.8332L8.16732 12.2498L9.33398 12.8332L10.5007 12.2498L11.6673 12.8332V1.1665L10.5007 1.74984L9.33398 1.1665L8.16732 1.74984L7.00065 1.1665L5.83398 1.74984L4.66732 1.1665L3.50065 1.74984L2.33398 1.1665",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 4.6665H5.83268C5.18878 4.6665 4.66602 5.18927 4.66602 5.83317C4.66602 6.47707 5.18878 6.99984 5.83268 6.99984H8.16602C8.80992 6.99984 9.33268 7.5226 9.33268 8.1665C9.33268 8.8104 8.80992 9.33317 8.16602 9.33317H4.66602",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.2082V3.7915",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg166);
export default __webpack_public_path__ + "static/media/svg166.e4ae00013710c7b0b8ff4d8244d5fce1.svg";
export { ForwardRef as ReactComponent };